export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/837e258702481769ad64684ae735d0c9.svg";